<div class="klab-chips-autocomplete" [class.klab-chips-autocomplete--block]="block">

  <div cdkOverlayOrigin #origin="cdkOverlayOrigin" #originRef class="klab-chips-autocomplete__control"
    [class.klab-chips-autocomplete__control--filled]="selectedItems.length > 0"
    [class.klab-chips-autocomplete__control--disabled]="disabled"
    [class.klab-chips-autocomplete__control--readonly]="readOnly" (mousedown)="onContainerClick()">

    <div class="klab-chips-autocomplete__texts">
      <span *ngIf="label" class="klab-chips-autocomplete__label">{{ label }}</span>
      <div class="klab-chips-autocomplete__chips">
        <span *ngFor="let item of selectedItems" class="klab-chips-autocomplete__chip">
          <span class="klab-chips-autocomplete__chip-label">{{ displayWith(item) }}</span>
          <button type="button" class="klab-chips-autocomplete__chip-remove" [attr.aria-label]="'Quitar'"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()" (click)="removeChip(item, $event)">
            <core-ui-icon name="ic_Close_24px" size="sm" color="#000000"></core-ui-icon>
          </button>
        </span>
        <span class="klab-chips-autocomplete__trigger" (mousedown)="$event.preventDefault()">{{ placeholder }}</span>
      </div>
    </div>
  </div>

  <div class="klab-chips-autocomplete__dropdown" *ngIf="panelOpen && !useOverlay" #panelEl role="listbox"
    (mousedown)="onPanelMouseDown()">

    <div class="klab-chips-autocomplete__dropdown-filter">
      <input #dropdownFilterInput type="text" class="klab-chips-autocomplete__dropdown-input"
        [placeholder]="placeholderDropdown" [value]="filterTerm" (input)="onFilterInputFromEvent($event)"
        (keydown)="onKeydown($event)" (blur)="onBlur()" />
    </div>

    <div class="klab-chips-autocomplete__dropdown-state" *ngIf="showMinCharsHint">
      Escribe al menos {{ minChars }} carácter(es) para buscar.
    </div>
    <div class="klab-chips-autocomplete__dropdown-state" *ngIf="loading">Buscando…</div>
    <div class="klab-chips-autocomplete__dropdown-state" *ngIf="showNoResults">No hay resultados.</div>

    <div class="klab-chips-autocomplete__dropdown-list">
      <button *ngFor="let item of results; let i = index; trackBy: trackByFn" type="button" role="option"
        class="klab-chips-autocomplete__option" [class.klab-chips-autocomplete__option--active]="i === activeIndex"
        (mouseenter)="activeIndex = i" (click)="selectItem(item, $event)">
        {{ displayWith(item) }}
      </button>
    </div>
  </div>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="panelOpen && useOverlay" [cdkConnectedOverlayWidth]="panelWidth ?? 240"
    [cdkConnectedOverlayHasBackdrop]="false" [cdkConnectedOverlayScrollStrategy]="overlayScrollStrategy"
    [cdkConnectedOverlayPositions]="overlayPositions" [cdkConnectedOverlayPanelClass]="overlayPanelClass"
    (detach)="onOverlayDetach()">
    <div class="klab-chips-autocomplete__dropdown" #panelEl role="listbox" (mousedown)="onPanelMouseDown()">

      <div class="klab-chips-autocomplete__dropdown-filter">
        <input #dropdownFilterInput type="text" class="klab-chips-autocomplete__dropdown-input"
          [placeholder]="placeholderDropdown" [value]="filterTerm" (input)="onFilterInputFromEvent($event)"
          (keydown)="onKeydown($event)" (blur)="onBlur()" />
      </div>

      <div class="klab-chips-autocomplete__dropdown-state" *ngIf="showMinCharsHint">
        Escribe al menos {{ minChars }} carácter(es) para buscar.
      </div>
      <div class="klab-chips-autocomplete__dropdown-state" *ngIf="loading">Buscando…</div>
      <div class="klab-chips-autocomplete__dropdown-state" *ngIf="showNoResults">No hay resultados.</div>

      <div class="klab-chips-autocomplete__dropdown-list">
        <button *ngFor="let item of results; let i = index; trackBy: trackByFn" type="button" role="option"
          class="klab-chips-autocomplete__option" [class.klab-chips-autocomplete__option--active]="i === activeIndex"
          (mouseenter)="activeIndex = i" (click)="selectItem(item, $event)">
          {{ displayWith(item) }}
        </button>
      </div>
    </div>
  </ng-template>
</div>